import Splash from './Splash.component';

export default Splash;
